import z from "zod/v4";

// AiNodeContextSchema and AiNodeContext are now exported from context-schemas.ts

export const CompressionOptionsSchema = z.object({
  enabled: z.boolean(),
  threshold: z.number().optional(), // Size threshold in bytes to trigger compression
});

export type CompressionOptions = z.infer<typeof CompressionOptionsSchema>;

export const ContextStorageOptionsSchema = z.object({
  compression: CompressionOptionsSchema,
  caching: z.object({
    enabled: z.boolean(),
    maxCacheSize: z.number().optional(), // Maximum cache size in MB
    ttl: z.number().optional(), // Cache TTL in milliseconds
  }),
});

export type ContextStorageOptions = z.infer<typeof ContextStorageOptionsSchema>;

export const ContextMetadataSchema = z.object({
  sessionId: z.string(),
  originalSize: z.number(),
  compressedSize: z.number().optional(),
  compressionRatio: z.number().optional(),
  createdAt: z.number(),
  lastAccessed: z.number(),
});

export type ContextMetadata = z.infer<typeof ContextMetadataSchema>;

export type CategoryContext = Record<string, string[]>;
